// import { Box, Grid, Typography, TextField, Button, IconButton } from "@mui/material";
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import PhoneIcon from '@mui/icons-material/Phone';
// import EmailIcon from '@mui/icons-material/Email';
// import { styles } from "../styles/styles";
// import { useNavigate } from "react-router-dom";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import InstagramIcon from "@mui/icons-material/Instagram";
// import { styled } from "@mui/material/styles";

// const CopyrightContainer = styled(Box)({
// 	borderTop: "1px solid #333",
// 	paddingTop: "16px",
// 	marginTop: "16px",
// 	width:"100%"

// });
// const Footer = () => {
// 	const navigate = useNavigate();
// 	let userType = sessionStorage.getItem("userType")
// 	let token
// 	if(userType){
// 		token = sessionStorage.getItem("token");
// 	}else{
// 		 token = localStorage.getItem("token");
// 	}
// 	const isLoggedIn = Boolean(token);
// 	const handleHomeClick = () => {
// 	  navigate(isLoggedIn ? "/profile/DetaliesDashbord?type=suggested-profiles" : "/");
// 	};
// 	return (
// 		<>
// 		<Box sx={{ backgroundColor: "#67156E", color: "white", pt: 4, pb: 4 }}>
// 			<Grid container spacing={3} sx={{ px: { xs: 2, md: 5 } }}>

// 				<Grid item xs={12} sm={6} md={4} textAlign="center">
// 					<Box
// 						component="img"
// 						src="/images/Frame 148.png"
// 						alt="Annapurna Marriages"
// 						sx={{ height: { xs: "60px", md: "80px",xl:"80px",xxl:"150px" }, mb: 1 ,cursor:"pointer"}}
// 						onClick={handleHomeClick}
// 					/>
// 					<Typography sx={{
// 						fontFamily: "SF Pro Display",
// 						fontWeight: 500,
// 						// fontSize: "24px",
// 						fontSize:{xs: "24px",sm: "24px",md: "24px",lg:"24px",xl: "24px",xxl:"40px"},

// 						lineHeight: "100%",
// 						letterSpacing: "0px",
// 						textAlign: "center",
// 						color: "white"
// 					}}>
// 						Finding Your Perfect Match Just Became Easier!
// 					</Typography>
// 				</Grid>

// 				<Grid item xs={12} sm={6} md={2}>
// 					<Typography variant='h6' sx={{ mb: 1,fontSize:{xs: "20px",sm: "20px",md: "20px",lg: "20px",xl: "20px",xxl:"30px"}}}>
// 	QUICK LINKS</Typography>
// 					<Typography sx={styles.footerlink} onClick={handleHomeClick}> {">"} Home</Typography>
// 					<Typography sx={styles.footerlink} onClick={() => navigate("/About")}> {">"} About</Typography>
// 					<Typography sx={styles.footerlink} onClick={() => navigate("/Help")}> {">"} Help</Typography>
// 					<Typography sx={styles.footerlink} onClick={() => navigate("/Career")}> {">"} Careers</Typography>
// 					<Typography sx={styles.footerlink} onClick={()=>navigate("/Contact")}> {">"} Contact Us</Typography>

// 				</Grid>

// 				<Grid item xs={12} sm={6} md={3}>
// 					<Typography variant='h6' sx={{ mb: 1,fontSize:{xs: "20px",sm: "20px",md: "20px",lg: "20px",xl: "20px",xxl:"30px"}}}>
// 					GET IN TOUCH</Typography>
// 					<Typography sx={{ display: "flex", alignItems: "center", ...styles.icon }}>
// 						<LocationOnIcon sx={{ mr: 1 }} /> Andhra Pradesh, IND
// 					</Typography>
// 					<Typography sx={{ display: "flex", alignItems: "center", ...styles.icon }}>
// 						<PhoneIcon sx={{ mr: 1 }} /> +91 9397979718,7731011119
// 					</Typography>
// 					<Typography sx={{ display: "flex", alignItems: "center", ...styles.icon }}>
// 						<EmailIcon sx={{ mr: 1 }} /> annapurnamarriages@gmail.com
// 					</Typography>
// 				</Grid>
// 				<Grid item xs={12} sm={6} md={3}>
// 				<Typography variant='h6' sx={{ mb: 1,fontSize:{xs: "20px",sm: "20px",md: "20px",lg: "20px",xl: "20px",xxl:"30px"}}}>
// 				NEWSLETTER</Typography>

// 					<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
// 						<TextField
// 							type="email"
// 							placeholder='Email'
// 							variant="outlined"
// 							size="small"
// 							sx={{
// 								input: { color: "white" },
// 								"& .MuiOutlinedInput-root": {
// 									"& fieldset": {
// 										borderColor: "white"
// 									},
// 									"&:hover fieldset": {
// 										borderColor: "#C1721F"
// 									}
// 								},
// 								width: "100%"
// 							}}
// 						/>
// 						<Button
// 							variant="contained"
// 							sx={{
// 								backgroundColor: "#fff",
// 								color: "#C1721F",
// 								fontWeight: 500,// 600
// 								width: "100%",
// 								padding: "10px",
// 								fontSize:{xxl:"40px"},
// 								"&:hover": {
// 									backgroundColor: "#C1721F",
// 									color: "white"
// 								}
// 							}}
// 						>
// 							SEND
// 						</Button>
// 					</Box>
// 				</Grid>
// 				<CopyrightContainer>
//   <Grid
//     container
//     spacing={2}
//     justifyContent="space-between"
//     alignItems="center"
//     sx={{
//       flexDirection: { xs: "column", sm: "row" },
//       textAlign: { xs: "center", sm: "left" },
// 	  paddingX:"10px"
//     }}
//   >
//     <Grid item>
// 	<Typography variant='h6' sx={{ mb: 1,fontSize:{xs: "20px",sm: "20px",md: "20px",lg: "20px",xl: "20px",xxl:"30px"}}}>
// 	2025 © Annapurna Marriages Pvt Ltd.
//       </Typography>
//     </Grid>

//     <Grid item>
//       <Box display="flex" gap={1} justifyContent={{ xs: "center", sm: "flex-end" }}>
//         <IconButton
//           sx={{
//           ...styles.iconbutton
//           }}
//         >
//           <TwitterIcon fontSize="small" />
//         </IconButton>
//         <IconButton
//          sx={{
// 			...styles.iconbutton
// 			}}
//         >
//           <FacebookIcon fontSize="small" />
//         </IconButton>
//         <IconButton
//          sx={{
// 			...styles.iconbutton
// 			}}
//         >
//           <LinkedInIcon fontSize="small" />
//         </IconButton>
//         <IconButton
//          sx={{
// 			...styles.iconbutton
// 			}}
//         >
//           <InstagramIcon fontSize="small" />
//         </IconButton>
//       </Box>
//     </Grid>
//   </Grid>
// </CopyrightContainer>

// 			</Grid>
// 		</Box>

// 		</>
// 	);
// };

// export default Footer;
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  IconButton,
} from "@mui/material";

import {
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  LinkedIn as LinkedInIcon,
  Instagram as InstagramIcon,
  LocationOn as LocationOnIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { FontStyles } from "../styles/FontStyles";
const styles = {
  footerlink: {
    color: "white",
    cursor: "pointer",
    mb: 1,
    "&:hover": { color: "#C1721F" },
  },
  icon: { color: "white", mb: 1 },
  iconbutton: {
    color: "white",
    border: "1px solid white",
    "&:hover": {
      color: "#C1721F",
      backgroundColor: "white",
    },
  },
};

export default function Footer() {

  const navigate = useNavigate();
  let userType = sessionStorage.getItem("userType")
  let token
  if (userType) {
    token = sessionStorage.getItem("token");
  } else {
    token = localStorage.getItem("token");
  }
  const isLoggedIn = Boolean(token);
  const handleHomeClick = () => {
    navigate(isLoggedIn ? "/profile/DetaliesDashbord?type=suggested-profiles" : "/");
  };
  return (
    <Box sx={{ backgroundColor: "#67156E", color: "white", pt: 4, pb: 2 }}>
      <Grid container spacing={4} sx={{ px: { xs: 2, md: 6 } }}>
        <Grid item xs={12} sm={6} md={3} textAlign="center">
          <Box
            component="img"
            src="/images/Frame 148.png"
            alt="Annapurna Marriages"
            sx={{
              height: { xs: "60px", md: "80px", xl: "80px", xxl: "150px" },
              mb: 1,
              cursor: "pointer",
            }}
            onClick={handleHomeClick}
          />
          <Typography sx={{ ...FontStyles.aboutText }}>

            Finding Your Perfect Match Just Became Easier!
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap", marginLeft: { md: "20px" } }}>
            <Box>
              <Typography sx={{ ...FontStyles.aboutText,marginLeft:{md:"-10px"} }}>
                QUICK LINKS
              </Typography>
              {["Home", "About", "Cmd", "Career", "Contact"].map((item) => (
                <Typography
                  key={item}
                  sx={{ ...FontStyles.FooterLINKtext }}
                  onClick={() => {
                    const path = item === "Home" ? "/" : `/${item.replace(" ", "")}`;
                    item === "Home" ? handleHomeClick() : navigate(path);
                  }}
                >
                  {">"} {item}
                </Typography>
              ))}
            </Box>

            <Box>
              <Typography sx={{ ...FontStyles.aboutText,marginLeft:{md:"-10px"} }}>
                HELP & CMD
              </Typography>
              {[
                ["FAQ", "/Faq"],
                ["Demo Video", "/Demo-Video"],
                ["Contact Admin", "/Contact-admin"],
                ["Advertisement Videos", "/Advertisement"],
              ].map(([text, path]) => (
                <Typography
                  key={text}
                  sx={{ ...FontStyles.FooterLINKtext }}
                  onClick={() => navigate(path)}
                >
                  {">"} {text}
                </Typography>
              ))}
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={2} sx={{ marginLeft: { md: "-90px" } }}>
          <Typography sx={{ ...FontStyles.aboutText,marginLeft:{md:"-10px"} }}>
            GET IN TOUCH
          </Typography>
          <Typography
            sx={{
              ...FontStyles.FooterCommontext
            }}
          >
            <LocationOnIcon sx={{ mr: 1 }} /> Andhra Pradesh, IND
          </Typography>
          <Typography
            sx={{
              ...FontStyles.FooterCommontext
            }}
          >
            <PhoneIcon sx={{ mr: 1 }} /> +91 9397979718
          </Typography>
          <Typography
            sx={{
              ...FontStyles.FooterCommontext
            }}
          >
            <EmailIcon sx={{ mr: 1 }} /> annapurnamarriages@gmail.com
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3} sx={{ marginLeft: { md: "90px" } }}>
          <Typography sx={{ ...FontStyles.aboutText }}>
            NEWSLETTER
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <TextField
              type="email"
              placeholder="Email"
              variant="outlined"
              size="small"
              sx={{
                input: { color: "white" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "white" },
                  "&:hover fieldset": { borderColor: "#C1721F" },
                },
                width: "100%",
              }}
            />
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#fff",
                color: "#C1721F",
                fontWeight: 600,
                padding: "15px",
                "&:hover": {
                  backgroundColor: "#C1721F",
                  color: "white",
                },
              }}
            >
              SEND
            </Button>
          </Box>
        </Grid>
      </Grid>


      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          borderTop: "1px solid #fff",
          mt: 4,
          pt: 2,
          px: { xs: 2, md: 6 },
          flexDirection: { xs: "column", sm: "row" },
          textAlign: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2, cursor: "pointer" }}
          onClick={handleHomeClick}
        >

          <Typography sx={{ ...FontStyles.aboutText }}>
            2025 © Annapurna Marriages Pvt Ltd.
          </Typography>
        </Box>

        <Box display="flex" gap={1}>
          <IconButton sx={styles.iconbutton}>
            <TwitterIcon fontSize="small" />
          </IconButton>
          <IconButton sx={styles.iconbutton}>
            <FacebookIcon fontSize="small" />
          </IconButton>
          <IconButton sx={styles.iconbutton}>
            <LinkedInIcon fontSize="small" />
          </IconButton>
          <IconButton sx={styles.iconbutton}>
            <InstagramIcon fontSize="small" />
          </IconButton>
        </Box>
      </Grid>
    </Box>
  );
}
